












































































































































































import BaseFilter from "@/components/Filter/BaseFilter";
import { Component, PropSync, Watch } from "vue-property-decorator";
import { DatePickerWings, FastDateGroupWings, SelectWings, NumberWings } from "wings-ui-components";
import { beginningOfCurrentDay, currentDate, dateFilter } from "@/utils/date-util";
import { Action, Getter, Mutation } from "vuex-class";
import { PushGroupFilterParams } from "@/store/push/statistic/types";
import { notifyError, notifyWarning } from "@/utils/notify-helper";
import { MsgTransports } from '@/store/types';
import {getTranslatedParams} from "@/utils/notify-utils";

@Component({
  components: {SelectWings, DatePickerWings, FastDateGroupWings, NumberWings},
  filters: {dateFilter}
})
export default class PushGroupFilter extends BaseFilter<PushGroupFilterParams> {
  @PropSync('show') is_show!: boolean;
  @PropSync("filterClone") propFilterClone!: any;

  @Mutation('setPushStatisticGroup') setStatistic: any

  @Getter("pushApplications") applicationsList!: any[];
  @Getter("pushOS") pushOSList!: string[];
  @Getter("pushGroupBy") groupByList!: string[];
  @Getter("pushGroupByOptionally") groupByOptionallyList!: string[];
  @Getter("messageTypes") messageTypesList: any;

  @Action("getPushStatisticGroup") actionGetStatistic: any;
  @Action("exportPushStatisticGroup") actionExport: any;
  @Action("getPartners") actionGetPartners: any;
  @Action("getPushApplications") actionGetPushApplications: any;
  @Action("getPushOS") actionGetPushOS: any;
  @Action("getAccounts") actionGetAccounts: any;
  @Action("getMessageTypes") actionGetMessageTypes: any;
  @Action("actionLog") actionLog: any;

  defaultFilter(): PushGroupFilterParams {
    return new PushGroupFilterParams(beginningOfCurrentDay(), currentDate(), "day");
  }

  params = {transport: MsgTransports.PUSH};
  partnersList: any = [];
  accountsList: any = []

  group_by = null;
  group_by_optionally = null;

  filterKeys: object = {
    "broker_account_login" : "account"
  }

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async getAccountsList(filter: any) {
    const items = await this.actionGetAccounts({...this.params, ...filter});
    this.accountsList = (filter?.page_number > 1) ? this.accountsList.concat(items) : items
  }

  async created() {
    this.setStatistic(null)
    this.parseGroupBy()
    try {
      this.actionGetPushApplications();
      this.actionGetPushOS();
      this.actionGetMessageTypes();
    } catch (err) {
      notifyError(err);
    }
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
    if (this.filter.broker_account_login) this.accountsList = await this.actionGetAccounts({login: this.filter.broker_account_login});
  }

  async onFilteredAction() {
    this.setStatistic(null);
    try {
      this.mergeGroupBy();
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Group statistics",
        addititional_info: getTranslatedParams(this.filter, this.filterKeys)
      };
      const resp = await this.actionGetStatistic(this.filter);
      await this.actionLog(this.logObject);
      if (resp.status == 204) {
        notifyWarning();
      }
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err);
    }
  }

  // Override
  async doActionExport(): Promise<any> {
    this.mergeGroupBy();
    return await this.actionExport(this.filter);
  }

  mergeGroupBy() {
    this.filter.group_by = [this.group_by, this.group_by_optionally].filter(item => item).join(',');
    this.$set(this.sendFilter, 'group_by', this.filter.group_by);
    this.$emit('onGroupByChange', {groupBy: this.group_by, optionallyGroupBy: this.group_by_optionally});
  }

  parseGroupBy() {
    if (this.filter.group_by.length == 0) return

    this.filter.group_by.split(',').forEach((item:any) => {
      if (this.groupByList.includes(item)) this.group_by = item;
      else this.group_by_optionally = item;
    })
  }


  @Watch('filter', { immediate: true, deep: true })
  onFilterChanged(newVal: PushGroupFilterParams) {
    this.propFilterClone = newVal;
  }
}
